export default "__VITE_ASSET__b3e66141__"